"use strict";

// This file is auto-generated by icons cli
module.exports = {
  'advice-circle--filled-off': require('./icons/advice-circle/filled=off.svg'),
  'advice-circle--filled-on': require('./icons/advice-circle/filled=on.svg'),
  'arrow-chevron--type-down': require('./icons/arrow-chevron/type=down.svg'),
  'arrow-chevron--type-left': require('./icons/arrow-chevron/type=left.svg'),
  'arrow-chevron--type-right': require('./icons/arrow-chevron/type=right.svg'),
  'arrow-chevron--type-up': require('./icons/arrow-chevron/type=up.svg'),
  'arrow-circle--type-down--filled-off': require('./icons/arrow-circle/type=down/filled=off.svg'),
  'arrow-circle--type-down--filled-on': require('./icons/arrow-circle/type=down/filled=on.svg'),
  'arrow-circle--type-left--filled-off': require('./icons/arrow-circle/type=left/filled=off.svg'),
  'arrow-circle--type-left--filled-on': require('./icons/arrow-circle/type=left/filled=on.svg'),
  'arrow-circle--type-right--filled-off': require('./icons/arrow-circle/type=right/filled=off.svg'),
  'arrow-circle--type-right--filled-on': require('./icons/arrow-circle/type=right/filled=on.svg'),
  'arrow-circle--type-up--filled-off': require('./icons/arrow-circle/type=up/filled=off.svg'),
  'arrow-circle--type-up--filled-on': require('./icons/arrow-circle/type=up/filled=on.svg'),
  'arrow-corner--type-left-down': require('./icons/arrow-corner/type=left-down.svg'),
  'arrow-corner--type-left-up': require('./icons/arrow-corner/type=left-up.svg'),
  'arrow-corner--type-right-down': require('./icons/arrow-corner/type=right-down.svg'),
  'arrow-corner--type-right-up': require('./icons/arrow-corner/type=right-up.svg'),
  'arrow-direction--type-down': require('./icons/arrow-direction/type=down.svg'),
  'arrow-direction--type-left': require('./icons/arrow-direction/type=left.svg'),
  'arrow-direction--type-right': require('./icons/arrow-direction/type=right.svg'),
  'arrow-direction--type-up': require('./icons/arrow-direction/type=up.svg'),
  'behance': require('./icons/behance.svg'),
  'brand-isotype': require('./icons/brand-isotype.svg'),
  'brand-logo': require('./icons/brand-logo.svg'),
  'calendar': require('./icons/calendar.svg'),
  'card': require('./icons/card.svg'),
  'chat': require('./icons/chat.svg'),
  'check-circle--filled-off': require('./icons/check-circle/filled=off.svg'),
  'check-circle--filled-on': require('./icons/check-circle/filled=on.svg'),
  'check': require('./icons/check.svg'),
  'close-circle--filled-off': require('./icons/close-circle/filled=off.svg'),
  'close-circle--filled-on': require('./icons/close-circle/filled=on.svg'),
  'close': require('./icons/close.svg'),
  'download': require('./icons/download.svg'),
  'email': require('./icons/email.svg'),
  'eye--type-off': require('./icons/eye/type=off.svg'),
  'eye--type-on': require('./icons/eye/type=on.svg'),
  'facebook': require('./icons/facebook.svg'),
  'file': require('./icons/file.svg'),
  'file_upload': require('./icons/file_upload.svg'),
  'github': require('./icons/github.svg'),
  'globe': require('./icons/globe.svg'),
  'home': require('./icons/home.svg'),
  'info-circle--filled-off': require('./icons/info-circle/filled=off.svg'),
  'info-circle--filled-on': require('./icons/info-circle/filled=on.svg'),
  'instagram': require('./icons/instagram.svg'),
  'link': require('./icons/link.svg'),
  'linkedin': require('./icons/linkedin.svg'),
  'logout': require('./icons/logout.svg'),
  'medium': require('./icons/medium.svg'),
  'menu': require('./icons/menu.svg'),
  'minus': require('./icons/minus.svg'),
  'more--type-horizontal': require('./icons/more/type=horizontal.svg'),
  'more--type-vertical': require('./icons/more/type=vertical.svg'),
  'notification--type-off': require('./icons/notification/type=off.svg'),
  'notification--type-on': require('./icons/notification/type=on.svg'),
  'pause--filled-off': require('./icons/pause/filled=off.svg'),
  'pause--filled-on': require('./icons/pause/filled=on.svg'),
  'pause-circle--filled-off': require('./icons/pause-circle/filled=off.svg'),
  'pause-circle--filled-on': require('./icons/pause-circle/filled=on.svg'),
  'pencil': require('./icons/pencil.svg'),
  'phone': require('./icons/phone.svg'),
  'play--filled-off': require('./icons/play/filled=off.svg'),
  'play--filled-on': require('./icons/play/filled=on.svg'),
  'play-circle--filled-off': require('./icons/play-circle/filled=off.svg'),
  'play-circle--filled-on': require('./icons/play-circle/filled=on.svg'),
  'plus': require('./icons/plus.svg'),
  'search': require('./icons/search.svg'),
  'settings': require('./icons/settings.svg'),
  'share': require('./icons/share.svg'),
  'slack': require('./icons/slack.svg'),
  'star--type-empty': require('./icons/star/type=empty.svg'),
  'star--type-filled': require('./icons/star/type=filled.svg'),
  'star--type-half': require('./icons/star/type=half.svg'),
  'toolbox': require('./icons/toolbox.svg'),
  'twitch': require('./icons/twitch.svg'),
  'twitter': require('./icons/twitter.svg'),
  'user': require('./icons/user.svg'),
  'vimeo': require('./icons/vimeo.svg'),
  'volume--type-down': require('./icons/volume/type=down.svg'),
  'volume--type-high': require('./icons/volume/type=high.svg'),
  'volume--type-off': require('./icons/volume/type=off.svg'),
  'whatsapp': require('./icons/whatsapp.svg'),
  'youtube': require('./icons/youtube.svg')
};